import { BASE_URL } from "../constants";
import api from "../middlware/api";
import { camelToSnake } from "../utils/CamelToSnake";

export const saveTransaction = (payload: any) => {
  return new Promise((resolve, reject) => {
    api
      .post(`${BASE_URL}/api/v1/patient-transactions`, camelToSnake(payload))
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const updateTransaction = (payload: any) => {
  return new Promise((resolve, reject) => {
    api
      .put(
        `${BASE_URL}/api/v1/visit-transactions/${payload.id}`,
        camelToSnake(payload)
      )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getTransaction = (payload: any) => {
  return new Promise((resolve, reject) => {
    api
      .get(`${BASE_URL}/api/v1/visit-transactions/${payload}`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export interface PaymentPayload {
  source_type: "lab_order" | "pharmacy_sale" | "visit"| "pathology";
  source_ids: number[];
  payments: Array<{
    amount: number;
    payment_mode: string;
    payment_date?: string;
    transaction_id?: string;
    notes?: string;
    allocation_type?: "auto" | "manual";
    allocation_notes?: string;
  }>;
  source_amounts?: Record<number, number>;
  invoice_date?: string;
}

export const processPayment = (payload: PaymentPayload) => {
  return new Promise((resolve, reject) => {
    api
      .post(`${BASE_URL}/api/v1/payments/process`, camelToSnake(payload))
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
